<template>
  <div v-if="auth">
    <v-btn text color="white" href="https://percap.se/help" target="_blank">
      <div class="icon-button-container">
        <div class="icon-button-text">
          Hjälp
        </div>
        <div class="icon-button-icon">
          <v-icon right style="color: rgba(255,255,255,1);">
            mdi-help-circle-outline
          </v-icon>
        </div>
      </div>
    </v-btn>

    <v-btn text color="white" @click="logout">
      <div class="icon-button-container">
        <div class="icon-button-text">
          Logga ut
        </div>
        <div class="icon-button-icon">
          <v-icon right style="color: rgba(255,255,255,1);">
            mdi-logout
          </v-icon>
        </div>
      </div>
    </v-btn>
  </div>
</template>

<script>
export default {
  computed: {
    auth() {
      return this.$store.getters["auth/auth"];
    }
  },
  methods: {
    async logout() {
      await this.$auth.logout();
      this.$router.push("/login");
    }
  }
};
</script>

<style></style>
